import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import { FleetActions } from '../../../actions';
import SubnavBar from '../../../components/SubnavBar';
import TitleBar from '../../../components/TitleBar';
import Assign from '../../../components/Fleet/Trackers/Assign';

class AssignTracker extends Component {
  constructor(props) {
    super(props);

    this.assignTracker = this.assignTracker.bind(this);
  }
  goBack = () => {
    browserHistory.push('/fleet/trackers');
  }
  assignTracker(values) {
    const { dispatch, params } = this.props;

    return dispatch(FleetActions.assignTracker(params.id, values)).then((response) => {
      browserHistory.push('/fleet/trackers');
    });

  }
  render() {
    const subnavItems = []
    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar items={subnavItems} back={this.goBack} />
          <TitleBar title="Assign Tracker" />
          <div className="row">
            <div className="col s12">
              <Assign onSubmit={this.assignTracker} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(AssignTracker);



// WEBPACK FOOTER //
// ./src/containers/Fleet/Trackers/Assign.js